/** @jsx jsx */

import React, { Fragment as _ } from 'react';
import { css, jsx } from '@emotion/core';
import Modal from 'components/UI/Modal';
import { colors } from 'styles/variables';
import checkReturnToInteractionEditing from 'services/checkReturnToInteractionEditing';
import EditableBtn from 'components/lib/EditableBtn';
import { useSelector } from 'react-redux';

const { lGrey0 } = colors;
const maxWidth = 512;

const Feedback = props => {
  const { useMediaInFeedback = true, onClose, children } = props;
  let [img, txt, btn] = children;

  // const imgProps = useSelector((state: any) => state.blocks[img.props.id]);
  // const btnProps = useSelector((state: any) => state.blocks[btn.props.id]);

  // img = React.cloneElement(img, imgProps);
  // btn = React.cloneElement(btn, btnProps);

  // console.log('>', imgProps);

  // const Btn = () => <_>{btn}</_>;

  //

  const isImg = img.props.child === 1;

  // const isVideo = img.props.child === 2;
  // if(isVideo) {
  //   console.log(img.props);
  // }

  return (
    <Modal onClose={() => onClose()}>
      <div
        css={css`
          position: relative;
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          height: 100%;
          max-width: 768px;
          padding: 50px;
        `}
      >
        {useMediaInFeedback && (
          <div
            css={css`
            width: 75%;

            // max-width: ${maxWidth * 0.75}px;
            // max-height: 40vh;
            margin-bottom: 30px;

            ${isImg &&
              `
              position: relative;
              min-height: 30vh;

            `}

            img {
              max-height: 30vh !important;
            }

            @media (max-width: 768px) {
              width: 100%;
              margin-bottom: 25px;
            }
          `}
          >
            {img}
          </div>
        )}

        <div
          css={css`
            width: 100%;
            margin-bottom: 30px;
          `}
        >
          {txt}
        </div>
        <div
          css={css`
            display: flex;
            justify-self: flex-end;
            justify-content: center;
            // bottom: 50px;
            width: 100%;
          `}
        >
          {window.dev() ? btn : React.cloneElement(btn, { onClick: onClose })}
          {/* {React.cloneElement(btn, { onClick: onClose })} */}
        </div>
      </div>
    </Modal>
  );
};

export default Feedback;
